<div class="main-container-left-side">
  <left-sport-menu-desktop></left-sport-menu-desktop>
</div>
<div id="main-page-second-scroll" class="main-container-article link-text text">
  <div *ngFor="let item of this.pageDetailList" [innerHTML]="item.HtmlContent" style="width: 100%"></div>
</div>
